export const BlueTag = () => {
   
        return(
            <span className="tag blue"> 2x1 </span>
        )
    
}